function initImageExplorers() {
  const imageExplorers = document.querySelectorAll(".image-explorer");
  if (!imageExplorers.length) return;

  imageExplorers.forEach((block) => {
    // Modal
    const blockId = block.getAttribute("id");
    const blockIdx = blockId?.replace(/^image-/, "");
    const modal = block.querySelector("dialog.image-explorer-modal") as HTMLDialogElement;
    const statusRegion = block.querySelector(`#image-status-${blockIdx}`);
    if (!modal) return;

    const modalContent = modal.querySelector(".image-explorer-modal-internal");

    const handleClose = () => {
      if (!modalContent) return;

      modal.classList.add("is-closing");

      const onAnimationEnd = (event: AnimationEvent) => {
        if (event.animationName === "slide-bottom") {
          modalContent.innerHTML = "";

          const currentMarker = block.querySelector(".image-explorer-marker[aria-expanded='true']");
          if (currentMarker) {
            currentMarker.setAttribute("aria-expanded", "false");
          }

          modal.classList.remove("is-closing");
          modal.removeEventListener("animationend", onAnimationEnd);
          modal.close();
          modal.removeAttribute("aria-labelledby");
          modal.removeAttribute("aria-describedby");

          if (statusRegion) {
            statusRegion.textContent = "Image Explorer closed";
          }
        }
      };

      modal.addEventListener("animationend", onAnimationEnd);
    };

    const replaceModalContent = (markerId: string) => {
      if (!modalContent) return;

      const markerContent = block.querySelector(`[id='${markerId}']`);
      if (!markerContent) return;

      modalContent.innerHTML = markerContent.innerHTML;
      modalActionsInit(markerId);

      // scroll to top
      modal.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };

    // Markers
    const handleMarkerSwitch = (targetIdx: number, currentMarkerIdx?: string) => {
      modal.showModal();

      const newMarkerId = `${blockId}-${targetIdx}`;
      replaceModalContent(newMarkerId);
      modal.setAttribute("aria-labelledby", `image-title-${targetIdx}`);
      modal.setAttribute("aria-describedby", `image-description-${targetIdx}`);

      block
        .querySelector(`[data-marker-id='${currentMarkerIdx}']`)
        ?.setAttribute("aria-expanded", "false");

      const targetMarker = block.querySelector(
        `.image-explorer-marker[data-marker-id='${newMarkerId}']`
      ) as HTMLButtonElement;
      if (targetMarker) {
        targetMarker.setAttribute("aria-expanded", "true");

        if (statusRegion) {
          const pilotText = targetMarker.getAttribute("aria-label");
          statusRegion.textContent = pilotText || "Image Explorer";
        }
      }
    };

    const markers = block.querySelectorAll(".image-explorer-marker");
    markers.forEach((marker) => {
      const markerId = marker.getAttribute("data-marker-id");
      const currentMarkerIdx = Number(markerId?.split("-")[2]);
      if (!currentMarkerIdx) return;

      // Modal open logic
      marker.addEventListener("click", () => {
        handleMarkerSwitch(currentMarkerIdx);

        // Escape key close
        const escHandler = (e: KeyboardEvent) => {
          if (e.key === "Escape") {
            e.preventDefault();
            handleClose();
            document.removeEventListener("keydown", escHandler);
          }
        };
        document.addEventListener("keydown", escHandler);
      });
    });

    // Actions
    const modalActionsInit = (markerId: string) => {
      const modalActionPrev = modal.querySelector(".controller-prev");
      const modalActionNext = modal.querySelector(".controller-next");
      const modalClose = modal.querySelector(".image-explorer-modal-dismiss") as HTMLButtonElement;
      const currentMarkerIdx = Number(markerId.split("-")[2]);
      if (!currentMarkerIdx) return;

      modalActionPrev?.addEventListener("click", () => {
        handleMarkerSwitch(currentMarkerIdx - 1, markerId);
      });

      modalActionNext?.addEventListener("click", () => {
        handleMarkerSwitch(currentMarkerIdx + 1, markerId);
      });

      modalClose?.addEventListener("click", handleClose);

      // arrow keys navigation
      const arrowKeysHandler = (e: KeyboardEvent) => {
        if (modal.open) {
          if (e.key === "ArrowLeft") {
            e.preventDefault();
            handleMarkerSwitch(currentMarkerIdx - 1, markerId);
          } else if (e.key === "ArrowRight") {
            e.preventDefault();
            handleMarkerSwitch(currentMarkerIdx + 1, markerId);
          } else if (e.key === "Escape") {
            e.preventDefault();
            handleClose();
          }
        }
      };
      document.addEventListener("keydown", arrowKeysHandler);
      modal.addEventListener("close", () => {
        document.removeEventListener("keydown", arrowKeysHandler);
      });
    };

    // Close modal on outside click
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        handleClose();
      }
    });
  });
}

initImageExplorers();
